import { calculateUtil } from 'pangu-core'
export default calculateUtil
